<template>
	<div :class="classes">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		xs: {
			type: [Number, String],
			default: 12
		},
		md: {
			type: [Number, String],
			default: 12
		},
		lg: {
			type: [Number, String],
			default: 12
		},
		formGroup: {
			type: Boolean
		}
	},
	computed: {
		classes() {
			return [
				`col-xs-${this.xs}`,
				`col-md-${this.md}`,
				`col-lg-${this.lg}`,
				{'form-group': this.formGroup}
			]
		}
	}
}
</script>
